/**
 * ContentTypes ids from Contentful
 */

export const PAGES = {
  HOME: 'PageHome',
  LANDING: 'PageLanding',
  DETAIL: 'PageDetail',
};
